import React, { useEffect, useRef, useState } from 'react';
import './index.less';
import FaeHeader from '../../components/FaeHeader';
import { BaseLabelType } from '@/types/message';
import { getFAEProjectDetail } from '@/api/technical';
import { Spin } from 'antd';


const prefix = 'fae-Project';
const MyProject: React.FC = () => {

  const [loading, setLoading] = useState<boolean>(true);
  const projectList = useRef< any[]>([{
    label: '项目名称：',
    value: 'projectName'
  }, {
    label: '公司名称：',
    value: 'companyName'
  }, {
    label: '联系方式：',
    value: 'contact'
  }, {
    label: '项目周期：',
    value: 'projectPeriod',
    unit:'天'
  }, {
    label: '开始时间：',
    value: 'projectStartTime'
  }, {
    label: '结束时间：',
    value: 'projectEndTime'
  }, {
    label: '生态经理：',
    value: 'introducerUser'
  }]);
  const [projectInfo, setProjectInfo] = useState<any>({});
  const getProject = () => {
    getFAEProjectDetail().then(res => {
      console.log(res);
      if (res.code == 200) {
        setProjectInfo(res.result);
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      setLoading(false);
    })
  }

  useEffect(() => {
    getProject();
  }, [])

  return (
    <div className={`${prefix} main-wrapper`}>
      <FaeHeader title={'我的项目'} />
      <Spin size='large' spinning={loading}>
        <div className={`${prefix}-content common-list-card`}>
          <div className={`${prefix}-content-title title`}>项目信息</div>
          <div className={`${prefix}-content-list`}>
            {
              projectList.current.map((item, index) => {
                return (
                  <div className={`${prefix}-content-list-item common-list-card-content`} key={index}>
                    <span className={`${prefix}-content-list-item-label label`}>{item.label}</span>
                    <span className={`${prefix}-content-list-item-value`}>{projectInfo?.[item.value] ? item?.unit? projectInfo?.[item.value]+item.unit: projectInfo?.[item.value] :'--'}</span>
                  </div>
                )
              }
              )
            }
          </div>
        </div>
      </Spin>

    </div>
  );
};

export default MyProject;
